import * as actionType from '../constants/constant.action';

export const claimsLoad = (memberId, memberHccId) => ({
  type: actionType.CLAIMS_LOAD,
  payload: {
    memberUuid: window.atob(memberId),
    memberHccId: memberHccId || '',
  },
});

export const getClaimsSummaryListStart = (payload) => ({
  type: actionType.GET_CLAIMS_SUMMARY_LIST_REQUEST,
  payload,
});

export const getClaimDetailStart = (payload) => ({
  type: actionType.GET_CLAIM_DETAIL_REQUEST,
  payload,
});

export const claimsSetUiState = (uiState) => ({
  type: actionType.CLAIMS_SET_UI_STATE,
  payload: uiState,
});

export const claimsClose = () => ({
  type: actionType.CLAIMS_CLOSE,
});

export const claimsClearDetail = () => ({
  type: actionType.CLAIMS_CLEAR_DETAIL,
});
